import React from "react"
import { Alert } from "antd"

interface IEmbargoBindMeta {
  disableBind?: boolean
  quoteHasEmbargoes?: boolean
  quoteEmbargoMessage?: string
}

interface IEmbargoBindState {
  bindDisabled: boolean | undefined
  embargoBindAlert: React.ReactNode
}

export const getEmbargoBindState = ({
  disableBind,
  quoteHasEmbargoes,
  quoteEmbargoMessage
}: IEmbargoBindMeta): IEmbargoBindState => {
  const bindDisabled = disableBind || quoteHasEmbargoes
  const embargoBindMessage = quoteHasEmbargoes
    ? `Quote cannot be bound as there is an associated embargo: ${
        quoteEmbargoMessage || "Unknown embargo reason"
      }`
    : undefined

  const embargoBindAlert = embargoBindMessage ? (
    <Alert
      type="error"
      message={embargoBindMessage}
      style={{ display: "inline-block", marginRight: 8, marginBottom: 0 }}
    />
  ) : null

  return { bindDisabled, embargoBindAlert }
}
